import { useState, useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ModalContext } from '../../components/contexts';
import { nlPost } from '../../apis/notLoginApi';

const JoinTermsEnt = () => {
  useEffect(() => {
    document.title = '기업 약관 동의';
  }, []);
  const location = useLocation();
  const navigate = useNavigate();
  const { modalService } = useContext(ModalContext);

  const [trmData, setTrmData] = useState([]);
  const [mode, setMode] = useState('');
  const [formData, setFormData] = useState({
    brNo: '', // 기업회원
    userEml: '', // 전문가
    utztnTrmsAgreYn: '',
    prvcClctAgreYn: '',
  });

  useEffect(() => {
    if (location.state && location.state.mode) {
      setMode(location.state.mode);
      if (location.state.mode === 'ent') {
        setFormData(prevFormData => ({
          ...prevFormData,
          brNo: location.state.brNo,
        }));
      } else if (location.state.mode === 'expt') {
        setFormData(prevFormData => ({
          ...prevFormData,
          userEml: location.state.userEml,
        }));
      }
    }
  }, [location.state]);

  const formatContent = content => {
    const withoutMarkdown = content.replace(
      /!\[.*?\]\((?!http)(.*?)\)|#/g,
      match => {
        if (match === '#') return '';
        return match;
      }
    );

    return withoutMarkdown
      .replace(/\s+/g, ' ')
      .trim()
      .replaceAll('&middot;', ' ');
  };

  useEffect(() => {
    const init = async () => {
      const url = '/member/mngTrms/list.do';

      let response;

      try {
        response = await nlPost(url, {});

        if (response instanceof Error) {
          modalService.errorAlert(
            '알림 - 약관 정보를 가져오는데 실패했습니다.'
          );
        } else {
          let temp = [];
          if (response?.uTrms?.trmsCn) {
            temp.push(formatContent(response?.uTrms?.trmsCn));
          } else {
            temp.push('');
          }
          if (response?.pTrms?.trmsCn) {
            temp.push(formatContent(response?.pTrms?.trmsCn));
          } else {
            temp.push('');
          }

          setTrmData(temp);
        }
      } catch (e) {}
    };
    init();
  }, []);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if (formData.prvcClctAgreYn == 'Y' && formData.utztnTrmsAgreYn == 'Y') {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [formData]);

  const handleLinkClick = () => {
    if (mode === 'ent') {
      navigate('/member/joinEnt', {
        state: {
          mode: mode,
          brNo: formData.brNo,
          utztnTrmsAgreYn: formData.utztnTrmsAgreYn,
          prvcClctAgreYn: formData.prvcClctAgreYn,
        },
      });
    } else if (mode === 'expt') {
      navigate('/member/joinExpt', {
        state: {
          mode: mode,
          userEml: formData.userEml,
          utztnTrmsAgreYn: formData.utztnTrmsAgreYn,
          prvcClctAgreYn: formData.prvcClctAgreYn,
        },
      });
    }
  };
  const cancel = () => {
    navigate('/member/login');
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">약관 동의</h2>
      </div>
      <ol className="step-wrap">
        <li className="done">
          <span>
            <i className="sr-only">1단계</i>
            <span className="step-tit">가입 유형 선택</span>
          </span>
        </li>
        <li className="done">
          <span>
            <i className="sr-only">2단계</i>
            <span className="step-tit">중복가입 확인</span>
          </span>
        </li>
        <li className="active">
          <span>
            <i className="sr-only">3단계 현재단계</i>
            <span className="step-tit">약관동의</span>
          </span>
        </li>
        <li>
          <span>
            <i className="sr-only">4단계</i>
            <span className="step-tit">정보입력</span>
          </span>
        </li>
        <li>
          <span>
            <i className="sr-only">5단계</i>
            <span className="step-tit">사용자 가입 완료</span>
          </span>
        </li>
      </ol>

      <h3 className="content-tit">약관 동의</h3>
      <p className="text-gray-70">
        하단의 이용약관과 개인정보취급방침에 동의하셔야 사용자가입이 가능합니다.
      </p>

      <div className="txt-box bg-white gap-md">
        <ul className="terms-agree-ul">
          <li>
            <h4 className="agree-tit">[필수] 이용약관</h4>
            <div
              className="txt-box bg-white"
              style={{ maxHeight: '300px', overflowY: 'auto' }}
            >
              <pre>{trmData?.[0]}</pre>
            </div>
            <div className="agree-box">
              <div className="chk-area">
                <div className="form-check">
                  <input
                    type="radio"
                    name="utztnTrmsAgreYn"
                    id="utztnTrmsAgreYnNo"
                    value="N"
                    checked={formData.utztnTrmsAgreYn === 'N'}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="utztnTrmsAgreYnNo">동의안함</label>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    name="utztnTrmsAgreYn"
                    id="utztnTrmsAgreYnYes"
                    value="Y"
                    checked={formData.utztnTrmsAgreYn === 'Y'}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="utztnTrmsAgreYnYes">동의함</label>
                </div>
              </div>
            </div>
          </li>
          <li>
            <h4 className="agree-tit">[필수] 개인정보의 수집 및 이용</h4>
            <div
              className="txt-box bg-white"
              style={{ maxHeight: '300px', overflowY: 'auto' }}
            >
              <pre>{trmData?.[1]}</pre>
            </div>
            <div className="agree-box">
              <div className="chk-area">
                <div className="form-check">
                  <input
                    type="radio"
                    name="prvcClctAgreYn"
                    id="prvcClctAgreYnNo"
                    value="N"
                    checked={formData.prvcClctAgreYn === 'N'}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="prvcClctAgreYnNo">동의안함</label>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    name="prvcClctAgreYn"
                    id="prvcClctAgreYnYes"
                    value="Y"
                    checked={formData.prvcClctAgreYn === 'Y'}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="prvcClctAgreYnYes">동의함</label>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div className="page-btn-wrap">
        <button type="button" className="btn xlg tertiary" onClick={cancel}>
          취소
        </button>
        <button
          type="button"
          className="btn xlg primary"
          disabled={isDisabled}
          onClick={handleLinkClick}
        >
          다음으로
        </button>
      </div>
    </>
  );
};

export default JoinTermsEnt;
